import Vue from 'vue'
import bootstrapVue from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/shepherd'
import '@/libs/vue-gtag'

// plugin
import '@/libs/plugin'

// Register Service worker
import './registerServiceWorker'

// BSV Plugin Registration
Vue.use(bootstrapVue)

// Composition API
Vue.use(VueCompositionAPI)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import vue-select styles
require('@core/scss/vue/libs/vue-select.scss')

require('vue-datamaps/dist/style.css')

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
